/**
 *  @internal The possible types of coupons.
 */
export var CouponType;
(function (CouponType) {
    CouponType["Cheque"] = "cheque";
    CouponType["Fixed"] = "fixed-discount";
    CouponType["Percentage"] = "percentage-discount";
    CouponType["NewPrice"] = "new-price";
})(CouponType || (CouponType = {}));
/**
 *  @internal The possible actions regarding a coupon.
 */
export var CouponAction;
(function (CouponAction) {
    CouponAction["Add"] = "add";
    CouponAction["Remove"] = "remove";
    CouponAction["Update"] = "update";
})(CouponAction || (CouponAction = {}));
//# sourceMappingURL=types.js.map